import { STORAGE_KEYS } from "../lib/constants"
import { supabase } from "../lib/supabase"

export function signout() {
  localStorage.removeItem(STORAGE_KEYS.USER_ID)
  localStorage.removeItem(STORAGE_KEYS.TENANT_ID)
  return supabase.auth.signOut()
}
